//CSS
import "../../Components/Page/Page.css";
import "./Boston.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { Link } from "react-router-dom";
import PipeDriveEmbed from "../../Pages/PipeDrive/PipeDriveEmbed";
import RequestInfoFrom from "../Forms/RequestInfoForm2/RequestInfoForm";

const BostonContent: React.FC = () => {
  return (
    <div id="Goals" className="sectionContainer">
      <SecHeader title="ICE GEMS Dynamic ELF-Tech™ Reveal" />
      <SubSection isSplit={false}>
        <div className="boston-description-container">
          <span className="hero-stat-value">
            Showing the world new engine tech for a better future
          </span>
          <br />
          <br />
          <div className="boston-subsection">
            Come and see our “Badger” diesel and “Dragonfly” UAV-tuned petrol
            test engines running with several industry firsts.
            <br />
            <br />
            <span className="boston-details">
              Wednesday, August 5, 2026
              <br />
              10:00 AM - 12:00 PM EST
              <br />
              Babson College, MA
            </span>
            <br />
            <br />
            Sponsored by ZIMTEX Energy, Pro-West, Canada, and E2A
            <br />
            <p>
              We will demonstrate new low friction, high displacement geometries
              with 100% balanced internals and valve trains, allowing engines to
              use valve timed two-stroke combustion with overexpansion for power
              density, efficiency, and cleaner running.
            </p>
            Stay tuned for more details.
          </div>
        </div>
      </SubSection>      
      <SecHeader title="Live Stream" />
      <SubSection>
        <div className="sectionContainer">
          <iframe
            className="boston-video"
            src="https://www.youtube.com/embed/QJJL-__k4po?si=mbPok5QVF53_3j39"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
          </iframe>
        </div>
      </SubSection>
      <SecHeader title="Contact Us" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            We would like to hear more from you. If you have not already done
            so, please create a <Link to="../user-login">user profile</Link> so
            we can better assist you with your inquiries.
          </p>{" "}
        </div>
      </SubSection>
      <SubSection isSplit={false}>
        <div className="request-info-container">
          <div
            className={`request-info-card light-mode`}
          >
            <RequestInfoFrom />
          </div>
        </div>
      </SubSection>

      <SecHeader title="More Information" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            Here is some additional information and links about us. Please feel
            free to reach out to us with any questions you may have, and we hope
            to see you at the event!
            <ul>
              <li>
                <Link to="/register">Register</Link>
              </li>
              <li>
                <Link to="/espec">ESPEC Calculator</Link>
              </li>
              <li>
                <Link to="/ourStory">About Us</Link>
              </li>
              <li>
                <Link to="/pipedrive">Contact Information</Link>
              </li>
            </ul>
          </p>{" "}
        </div>
      </SubSection>
    </div>
  );
};

export default BostonContent;
